import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import fetchUtil from '../../utils/fetchUtil';
import ErrorComponent from '../../components/ErrorComponent';
import AdmissionsDayLanding from '../../components/AdmissionsDay/AdmissionsDayLanding';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';

const AdmissionsDay: React.FC = (props: any) => {
    if (!props.pageData || props.pageData.length === 0) {
        return <ErrorComponent />
    }

    return (
        <AdmissionsDayLanding {...props} />
    )
}

export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: [], fallback: 'blocking' };
}

export const getStaticProps: GetStaticProps = async (context) => {
    try {
        const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/admissions-day-pages?newSlug=${context.params?.slug}&categoryType=virtual_admissions_day`, 'GET', {}, '', false)
        return {
            props: {
                pageData
            },
            revalidate: CACHE_REVALIDATE_24H,
        };
    } catch (e) {
        return {
            props: {
                pageData: []
            },
            revalidate: CACHE_REVALIDATE_24H,
        };
    }
}

export default AdmissionsDay;
